import { useAjax, useMzMutation } from "@harea/component";

export const useValidateDayOffMutation = (config?: any) => {
    const ajax = useAjax();
    return useMzMutation(async (payload: number | { id: number; data?: Record<string, any> }) => {
        const id = typeof payload === 'number' ? payload : payload.id;
        const data = typeof payload === 'number' ? {} : payload.data ?? {};
        try {
            return await ajax.send({
                type: "POST",
                content_type: "application/json",
                url: `project/dayoff/${id}/validate`,
                data,
            });
        } catch (err: any) {
            if (err?.response && typeof err.response === 'string') {
                try { err.response = JSON.parse(err.response); } catch { /* keep as-is */ }
            }
            throw err;
        }
    }, config ?? { error_message: false });
};